import { useInfiniteQuery } from "@tanstack/react-query";
import _ from "lodash";
import ThumbnailsGrid from "../../components2/ThumbnailsGrid/ThumbnailsGrid";
import Button, { BUTTON_VARIANTS } from "../../components2/UI/Button/Button";
import Container from "../../components2/UI/Container/Container";
import Group from "../../components2/UI/Group/Group";
import PageTitle from "../../components2/UI/PageTitle/PageTitle";
import { fetchMembers, MEMBERS_KEY } from "../../../api/public-voissa/members";
import MemberCard from "./components/MemberCard/MemberCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBowArrow, faRadar, faSignalBars, faSlider, faSparkle, faTransgender, faBadgeCheck } from "@fortawesome/pro-light-svg-icons";
import useCurrentUser from '../../../hooks/useCurrentUser';
import { Fragment, useContext, useState } from "react";
import useFilters from "../../../hooks/useFilters";
import Drawer from "../../components2/Drawer/Drawer";
import MenuList, { MenuListGroup, MenuListItemCheck } from "../../components2/MenuList/MenuList";
import InfiniteScroll from "react-infinite-scroll-component";
import InfiniteScrollLoading from "../../components2/InfiniteScrollLoading/InfiniteScrollLoading";
import DrawerLocation from "./components/DrawerLocation/DrawerLocation";
import DrawerMeet from "./components/DrawerMeet/DrawerMeet";
import { ModalContext } from "../../components2/ModalManager";
import useRestriction from "../../../hooks/useRestriction";
import CONTENT_RESTRICTION_RULE from "../../../const/contentRestrictionRule";
import { Helmet } from "react-helmet";
import DrawerAvatar from "./components/DrawerAvatar/DrawerAvatar";
import InputRange from "../../components2/UI/InputRange";
import { GENDER, GENDER_NAME_LABEL } from "../../../const/user";


let filters = {
    arroundMe : {
        multiple : false,
        defaultValue : false,
    },
    connected : {
        multiple : false,
        defaultValue : false,
    },
    openToMeet : {
        multiple : false,
        defaultValue : false,
    },
    newMembers : {
        multiple : false,
        defaultValue : false
    },
    gender : {
        multiple : true,
        uriParam : "gender",
        label : "Genre",
        defaultValue : [],
        options: [
            {
                label: `Les ${GENDER_NAME_LABEL.MAN.toLowerCase()}s`,
                uriParam: `${GENDER_NAME_LABEL.MAN.toLowerCase()}s`,      // "hommes"
                value: GENDER.MAN
            },
            {
                label: `Les ${GENDER_NAME_LABEL.WOMAN.toLowerCase()}s`,
                uriParam: `${GENDER_NAME_LABEL.WOMAN.toLowerCase()}s`,    // "femmes"
                value: GENDER.WOMAN
            },
            {
                label: `Les ${GENDER_NAME_LABEL.COUPLE.toLowerCase()}s`,
                uriParam: `${GENDER_NAME_LABEL.COUPLE.toLowerCase()}s`,   // "couples"
                value: GENDER.COUPLE
            },
            {
                label: GENDER_NAME_LABEL.NON_BINARY,                      // "Non-binaire / Genderqueer"
                uriParam: "non-binaire",                                  // slug simple
                value: GENDER.NON_BINARY
            }
        ]
    },
    ageRange : {
        multiple : false,
        uriParam : "ageRange",
        label : "Age",
        defaultValue : [18, 65]
    },
    certified : {
        multiple : false,
        defaultValue : false,
    }
}

const isValidCoordinates = (lat, lng) => {
    if (lat && lng) {
        if (lat < -90 || lat > 90) {
            return false;
        }
        if (lng < -180 || lng > 180) {
            return false;
        }
        return true;
    }
    return false;
}

const Members = () => {
    const showAvatarDrawer = sessionStorage.getItem('member-avatar-drawer') !== 'true';
    const { openModal } = useContext(ModalContext);
    const [ageRange, setAgeRange] = useState([18, 65]);
    const currentUser = useCurrentUser();
    const {isRestricted, restrictionHandler} = useRestriction(CONTENT_RESTRICTION_RULE.MEMBERS_FILTER);
    const memberFilter = useFilters(filters, 'members');
    const [toogleFiltersGender, setToogleFiltersGender] = useState(false);
    const [toogleFiltersAge, setToogleFiltersAge] = useState(false);
    const [toogleLocation, setToogleLocation] = useState(false);
    const [toogleMeet, setToogleMeet] = useState(false);
    const [toogleAvatar, setToogleAvatar] = useState(currentUser && !currentUser?.profile?.avatar && showAvatarDrawer);
    // const [filter, setFilter] = useState({});


    const {data : members, fetchNextPage,isFetched, isLoading, hasNextPage} = useInfiniteQuery(
        [MEMBERS_KEY, memberFilter.apiFilter],
        ({pageParam = 1})=> fetchMembers({...memberFilter.apiFilter, page : pageParam}),
        {
            staleTime : (1000 * 60 * 1),
            getNextPageParam: (lastPage, pages) => {
                return lastPage && lastPage.more ? pages.length + 1 : undefined
            }
        }
    );

    // console.log(members);
    // const handleFilter = (filterName, value) => {
    //     if(value === undefined || value === null){
    //         setFilter(({[filterName] : _, ...rest}) => rest);
    //         return;
    //     }
    //     setFilter({
    //         ...filter,
    //         [filterName] : value
    //     });
    // }

    // const toggleFilter = (filterName) => {
    //     if(filter[filterName]){
    //         handleFilter(filterName, null);
    //     }else{
    //         handleFilter(filterName, 1);
    //     }
    // }

    const handleCloseAvatar = () => {
        sessionStorage.setItem('member-avatar-drawer', 'true');
        setToogleAvatar(false);
    }

    const handleGuest = () => {
        openModal('Signin', {lockedAction : 'FILTER_MEMBERS'});
    }

    const handleRestricted = () => {
        restrictionHandler();
    }

    const handleFilterArroundMe = () => {
        if(!currentUser) return handleGuest();
        if(isRestricted) return handleRestricted();
        const [lat, lng] = currentUser?.location?.coordinate?.coordinates || [];
        if(!isValidCoordinates(lat, lng)) setToogleLocation(true);
        else memberFilter.toggleValue('arroundMe');   
    }
    const handleFilterConnected = () => {
        if(!currentUser) return handleGuest();
        if(isRestricted) return handleRestricted();
        memberFilter.toggleValue('connected');
    }
    const handleFilterOpenToMeet = () => {
        if(!currentUser) return handleGuest();
        if(isRestricted) return handleRestricted();
        if(!currentUser?.setting?.appearInDating) setToogleMeet(true);
        else memberFilter.toggleValue('openToMeet');
    }
    const handleFilterNewMembers = () => {
        if(!currentUser) return handleGuest();
        if(isRestricted) return handleRestricted();
        memberFilter.toggleValue('newMembers');
    }
    const handleFilterGender = () => {
        if(!currentUser) return handleGuest();
        setToogleFiltersGender(true);
    }
    const handleFilterAge = () => {
        if(!currentUser) return handleGuest();
        if(isRestricted) return handleRestricted();
        setToogleFiltersAge(true);
    }

    const handleFilterCertified = () => {
        if(!currentUser) return handleGuest();
        if(isRestricted) return handleRestricted();
        memberFilter.toggleValue('certified');
    }

    const ageRangeIsActive = memberFilter.getValue('ageRange') && memberFilter.getValue('ageRange').length === 2 && 
        !(memberFilter.getValue('ageRange')[0] === 18 && 
        memberFilter.getValue('ageRange')[1] === 65);

    let listPages = _.get(members, 'pages') || [];
    let totalMembers = _.get(members, 'pages[0].total') || 0;
    let allData = [];
    if (members?.pages) {
        for (let page of members.pages) {
            allData = [...allData, ...page.data];
        }
    }
    
    return (
        <>
            <Helmet>
                <title>Recherche de membres et rencontres sur Voissa</title>
                <meta name="description" content="Découvrez les membres en ligne, proches de chez vous, ouverts à la rencontre, selon vos goûts et attirances, pour entrer en contact !"></meta>
            </Helmet>
            <Container id="members">
                <DrawerLocation open={toogleLocation} handleClose={()=>setToogleLocation(false)}/>
                <DrawerMeet open={toogleMeet} handleClose={()=>setToogleMeet(false)}/>
                <DrawerAvatar open={toogleAvatar} currentUser={currentUser} handleClose={handleCloseAvatar}/>
                <Drawer 
                    small
                    open={toogleFiltersGender} 
                    handleClose={()=>setToogleFiltersGender(false)} 
                    >
                    <MenuList style={{padding:'10px', paddingTop:'16px'}}>
                        <MenuListGroup label={filters.gender.label}>
                            {filters.gender.options.map((option, optionIndexe) => (
                                <MenuListItemCheck key={optionIndexe} onClick={()=> {
                                    memberFilter.toggleValue('gender', optionIndexe);
                                }} active={memberFilter.getValue('gender').includes(option.value)}>{option.label}</MenuListItemCheck>
                            ))}
                        </MenuListGroup>              
                    </MenuList>
                </Drawer>
                <Drawer 
                    small
                    open={toogleFiltersAge} 
                    headContent="Selectionnez une tranche d'âge"
                    handleClose={()=>setToogleFiltersAge(false)} 
                    >
                        <div style={{padding:'16px 32px', width:'100%'}}>
                            <InputRange min={18} max={65} moreThanMax={true} onChange={(value)=>setAgeRange(value)} defaultValue={memberFilter.getValue('ageRange')}/>
                            
                        <Group style={{marginTop:'16px', width:'100%'}} split>
                            <Button 
                                disabled={!ageRangeIsActive}
                                onClick={()=> {
                                    memberFilter.setValue('ageRange', [18, 65]);
                                    setToogleFiltersAge(false);
                                }}>Tous les âges</Button>
                            <Button 
                                variant={BUTTON_VARIANTS.REVERSE}
                                onClick={()=> {
                                    memberFilter.setValue('ageRange', ageRange);
                                    setToogleFiltersAge(false);
                                }}>Valider</Button>
                        </Group>    
                        </div>
                </Drawer>
                <Container hasPadding>
                    <PageTitle>Membres</PageTitle>
                    <Group grid style={{marginBottom:'12px'}}>
                        <Button onClick={handleFilterGender} active={!!memberFilter.getValue('gender').length}><FontAwesomeIcon icon={faTransgender}/> Genre</Button>
                        <Button onClick={handleFilterArroundMe} active={memberFilter.getValue('arroundMe')}><FontAwesomeIcon icon={faRadar}/> Autour de moi</Button>
                        <Button onClick={handleFilterConnected} active={memberFilter.getValue('connected')}><FontAwesomeIcon icon={faSignalBars}/> En ligne</Button>
                        <Button onClick={handleFilterOpenToMeet} active={memberFilter.getValue('openToMeet')}><FontAwesomeIcon icon={faBowArrow}/> Ouvert à la rencontre</Button>
                        <Button onClick={handleFilterNewMembers} active={memberFilter.getValue('newMembers')}><FontAwesomeIcon icon={faSparkle}/> Nouveau</Button>
                        <Button onClick={handleFilterCertified} active={memberFilter.getValue('certified')}><FontAwesomeIcon icon={faBadgeCheck}/> Certifié</Button>
                        <Button onClick={handleFilterAge} active={ageRangeIsActive}><FontAwesomeIcon icon={faSlider}/> Age</Button>
                    </Group>
                </Container>
                
                <InfiniteScroll
                    dataLength={listPages.length}
                    next={() => fetchNextPage()}
                    hasMore={hasNextPage}
                    loader={<InfiniteScrollLoading/>}
                > 
                    <ThumbnailsGrid emptyMessage="Aucun membre trouvé  😞" hasData={totalMembers} initialized={!isLoading && isFetched}>
                        {listPages.map((data, page) =>(
                            <Fragment key={`page_${page}`}>
                                {data.data.map((member) => (
                                    <MemberCard key={member._id} member={member}/>
                                ))}
                            </Fragment>
                        ))}
                    </ThumbnailsGrid>
                </InfiniteScroll>
            </Container>
        </>
    );
    }
export default Members;